// BFSG
import { theme } from 'containers/GlobalStyle'
import useTranslations from 'hooks/useTranslations'
import { useFilter } from 'modules/productDetail'
import React from 'react'
import styled from 'styled-components'
import SizeTable from '../../BuyBox/SizeTable/SizeTable'
import CheckRadio from 'theme/atoms/CheckRadio'

type Props = {
  filterKey: 'size' | 'variant' | 'style'
  label: 'size_label' | 'style_label' | 'variant_label'
}

export default function Filter(props: Props) {
  const filter = useFilter(props.filterKey)
  const t = useTranslations<'templates-PDP'>()
  const { options } = filter.data

  if (filter.hideFilter) return null

  return (
    <Wrapper data-cy-collection="Filter">
      <h3 className="label">{t(props.label)}</h3>
      <div className="filter-grid">
        {options.map((option) => (
          <CheckRadio
            key={option.label}
            onClick={() => {
              filter.setValue(option.label)
            }}
            label={option.label}
            checked={option.label === filter.data.value}
            variation="radio"
            radiogroup={'FilterDrawer-' + props.label}
            notAvailable={!option.selectable}
            data-cy-handle="option"
            ariaLabel={t.asText(false, 'filterdrawer_option_title', {
              filterKey: props.label,
              filterOption: option.label
            })}
          />
        ))}
      </div>
      {props.filterKey === 'size' && (
        <div className="size-table" data-cy-state={'sizechart-shown'}>
          <SizeTable context="Overlay"></SizeTable>
        </div>
      )}
      <span className="divider" />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  > h3 {
    margin: ${theme.spacing('ml')} ${theme.spacing('ml')};
    ${theme.ty('r-base', null, 'r-xl')}
  }
  > .filter-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: ${theme.spacing('xs')};
    margin: 0 ${theme.spacing('ml')};
  }
  > .divider {
    display: block;
    margin-top: 25px;
    margin: ${theme.spacing('ml')} ${theme.spacing('ml')};
    border-bottom: 1px solid ${theme.colors.shade.b5};
  }
  > div.size-table {
    margin: ${theme.spacing('ml')};
  }
`
